<template>
  <v-dialog
      v-model="showDialog"
      max-width="400px"
      persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Neue Phase</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col md="4">
              <label class="v-label theme--light" style="margin-top: 10px">Phasenbegin:</label>
            </v-col>
            <v-col>
              <datetime
                  style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                  v-model="phaseStart"
                  input-class="form-control text-center"
                  input-style="color: black;"
                  :phrases="datetimeConfig.phrases"
                  :format="{  month: 'long', day: '2-digit' }"
                  :min-datetime="datetimeConfig.minTime"
                  :max-datetime="datetimeConfig.maxTime"
                  hide-year></datetime>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="4">
              <label class="v-label theme--light" style="margin-top: 10px">Phasenende:</label>
            </v-col>
            <v-col>
              <datetime
                  style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                  v-model="phaseEnd"
                  input-class="form-control text-center"
                  input-style="color: black;"
                  :phrases="datetimeConfig.phrases"
                  :format="{  month: 'long', day: '2-digit' }"
                  :min-datetime="datetimeConfig.minTime"
                  :max-datetime="datetimeConfig.maxTime"
                  hide-year></datetime>
            </v-col>
          </v-row>
          <v-alert
              v-if="error"
              border="left"
              colored-border
              type="error"
              elevation="2"
              style="margin-bottom: 0px; margin-top: 10px;"
          >
            Diese Phase überschneidet sich mit einer anderen Phase.
          </v-alert>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="!canSubmit"
        >
          Anlegen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import {v4} from "uuid";
import {DateTime as LuxonDateTime} from "luxon";

export default {
  name: "new_phase_dialog",
  props: {
    phases: {
      type: Array,
    },
  },
  data () {
    return {
      showDialog: false,
      phaseStart: null,
      phaseEnd: null,
      datetimeConfig: {
        phrases: {ok: 'Ok', cancel: 'Abbruch'},
        minTime: LuxonDateTime.local(2124, 1, 1, 12).toISO(),
        maxTime: LuxonDateTime.local(2124, 12, 31, 12).toISO(),
      },
      error: false,
    }
  },
  computed: {
    canSubmit() {
      return this.phaseStart && this.phaseEnd && !this.error;
    }
  },
  watch: {
    phaseStart(newValue) {
      this.hasError();
    },
    phaseEnd(newValue) {
      this.hasError();
    }
  },
  methods: {
    hasError() {
      if (this.phaseStart && this.phaseEnd && this.phases && this.phases.length) {
        let start = this.phaseStart.substring(5, 10)
        let end = this.phaseEnd.substring(5, 10)
        for (let phase of this.phases) {
          if (this.doPhasesOverlap(phase.active_from, phase.active_to, start, end) ||
              this.doPhasesOverlap(start, end, phase.active_from, phase.active_to)) {
            this.error = true;
            return;
          }
        }
        this.error = false;
      } else {
        this.error = false;
      }
    },
    doPhasesOverlap(start1, end1, start2, end2) {
      // first check if the phases have the same start or end dates
      if (start1 === start2 || start1 === end2 || end1 === start2 || end1 === end2) {
        return true;
      }
      if (start1 > end1) {
        // start1 is in the next year
        if (start2 > end2) {
          // start2 is in the next year
          return true;
        } else {
          // start2 is in the same year
          return  start1 <= end2 || end1 >= start2;
        }
      } else {
        // start1 is in the same year
        if (start2 > end2) {
          // start2 is in the next year
          return start2 <= end1 || end2 >= start1;
        } else {
          // start2 is in the same year
          return start1 >= start2 && start1 <= end2;
        }
      }
    },
    show() {
      this.phaseStart = null;
      this.phaseEnd = null;
      this.showDialog = true;
    },
    submit() {
      this.$emit('submit', this.phaseStart.substring(5, 10), this.phaseEnd.substring(5, 10));
      this.showDialog = false;
    }
  }
}
</script>

<style scoped>

</style>
